export default function round(num: number, decimalPlaces = 0): number {
	return (
		Math.round(num * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces)
	);
}
